import type { StrategySnapshot } from "@/lib/strategy-snapshot";
import { BUILTIN_STRATEGIES } from "@/mocks/builtin-strategies";
import {
  getProductDecision,
  STRATEGY_PRODUCT,
  STRATEGY_TACTIC_IDS,
} from "@/mocks/strategy-product";

export { BUILTIN_STRATEGIES };

export interface Strategy {
  id: string;
  name: string;
  source: "builtin" | "custom" | "ai";
  goal: string;
  asin?: string;
  productStage?: string;
  mode?: string;
  updatedAt: string;
  tacticIds: string[];
  description?: string;
  sections?: { title: string; body: string }[];
  campaigns?: string[];
}

export const AUTO_EXPLORATION_STRATEGY: Strategy = {
  ...BUILTIN_STRATEGIES.find((strategy) => strategy.id === "builtin-28")!,
  id: "builtin-auto-exploration",
};

export const GENERIC_TACTIC_IDS = [
  "builtin-01",
  AUTO_EXPLORATION_STRATEGY.id,
  "builtin-13",
  "builtin-21",
  "builtin-26",
] as const;

export function buildProductStrategy(
  snapshot: StrategySnapshot,
  id: string,
  name: string,
  goal?: string,
): Strategy {
  const decision = getProductDecision(snapshot, goal);
  return {
    id,
    name,
    source: "ai",
    goal: "保持稳定",
    asin: STRATEGY_PRODUCT.asin,
    mode: "人工确认",
    updatedAt: "",
    tacticIds: [...STRATEGY_TACTIC_IDS],
    description: decision.summary,
    sections: [
      { title: "策略决策", body: decision.rationale },
      { title: "投放安排", body: decision.budget },
      { title: "扩量条件", body: decision.safeguards },
    ],
    campaigns: decision.proposedGroups.map((label) => `${STRATEGY_PRODUCT.asin}-SP-${label}`),
  };
}

export const KEYWORD_SCREENING_COLUMNS = ["关键词", "月搜索量", "相关性", "建议"] as const;

export const KEYWORD_SCREENING: readonly (readonly [string, number, string, string])[] = [
  ["insulated travel mug", 48200, "高", "精准投放"],
  ["travel mug with lid", 36500, "高", "精准投放"],
  ["stainless steel coffee tumbler", 29800, "高", "词组投放"],
  ["20 oz tumbler", 21700, "中", "广泛投放"],
  ["thermos travel mug", 18900, "中", "竞品截流"],
  ["leak proof coffee mug", 12400, "中", "词组投放"],
  ["cup for kids", 9600, "低", "否定"],
];

const customNames = [
  "AuroraHub Direct · 白小芸",
  "HaHbHc-FitDirect · 邓丽",
  "Honpigeon · 华燕珊",
  "MCRG Direct · 姜巧君",
  "AuroraHub Direct · 焦聪",
];
const customGoals = ["保持稳定", "保利润做长线", "冲销量排名", "保持稳定", "冲销量排名"];

export const INITIAL_STRATEGIES: Strategy[] = customNames.map((name, index) => ({
  id: `custom-${index + 1}`,
  name,
  source: "custom",
  goal: customGoals[index] ?? "待补充",
  updatedAt: "",
  tacticIds: index === 0 ? ["builtin-01"] : [],
}));
